import { ICategory } from './../models/category.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';
import { ProductType } from '../models/productType.model';
import { Shop } from '../models/shop.model';

@Injectable({
  providedIn: 'root'
})

export class CategoryService {

  constructor(private http: HttpClient) {}

  getCategory(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/category`, {'headers': headers});
  }

  getCategoryAll(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/category/all`);
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/category` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getCategoryBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/category` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  saveCategory(Category: ICategory) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/category`, Category, {'headers': headers});
  }

  getIdCategory(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/category/` + idA, {'headers': headers});
  }

  getIdCategory_v1(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/category/back/` + idA, {'headers': headers});
  }

  getproductTypeByCategory(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/category/back/productType/` + idA, {'headers': headers});
  }

  getShopByCategory(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/category/back/shop/` + idA, {'headers': headers});
  }

  updateCategory(Category: ICategory) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/category/` + Category.id, Category, {'headers': headers});
  }

  updateCategory_v1(Category: ICategory) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/category/back/` + Category.id, Category, {'headers': headers});
  }

  deleteCategory(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/category/back/` + idA, {'headers': headers});
  }

  getAllCategories_v1(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/category/back`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  getAllCategories_v2(page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/category/back`+ (size ? '?page=' + page + '&size=' + size : ''), {'headers': headers});
  }

  getAllCategories_v3(page: number, size: number, nameSearchText: string = ''): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));

    let url = `${environment.url}/category/back/all?page=${page}&size=${size}`;
    if (nameSearchText) {
        url += `&nameSearchText=${encodeURIComponent(nameSearchText)}`;
    }

    return this.http.get<any>(url, { 'headers': headers });
  }


  saveCategorie_v1(categorie: ICategory) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/category/back`, categorie, {'headers': headers});
  }

  updateCategorie_v1(categorie: ICategory) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/category/back/`+ categorie.id, categorie, {'headers': headers});
  }

  moveProductTypesList(productTypeList: ProductType[], idCategorieB: number) {
    let headers = new HttpHeaders().set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));

    return this.http.put<any>(
        `${environment.url}/product_type/move/list?idCategorieB=${idCategorieB}`,
        productTypeList, 
        { headers } 
    );
}

changeCayegorieForShopList(shopList: Shop[], idCategorieB: number) {
  let headers = new HttpHeaders().set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));

  return this.http.put<any>(
      `${environment.url}/category/back/move/list?idCategorieB=${idCategorieB}`,
      shopList, 
      { headers } 
  );
}


  getCategoryById_v1(idC: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/category/` + idC, {'headers': headers});
  }

  deleteCategorie_v1(idC: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/category/back/` + idC, {'headers': headers});
  }

  // Méthode pour déplacer les productTypes d'une catégorie à une autre
  moveProductTypes(idCategorieA: number, idCategorieB: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/api/product_type/move?idCategorieA=${idCategorieA}&idCategorieB=${idCategorieB}`, {'headers': headers});
  }

}
